import { CreateTierBody, Tier, UpdateTierBody } from '@core/models/tier.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class TierService {
    private readonly createTierURL = `/admin/create_tier`;
    private readonly getTiersURL = `/admin/get_tiers`;
    private readonly getTierByIdURL = `/admin/get_tier_by_id`;
    private readonly updateTierURL = `/admin/update_tier`;
    private readonly deleteTierURL = `/admin/delete_tier`;

    // ---------------------------------------------------------------

    createTier(body: CreateTierBody) {
        return fetchWithRetry(API.post(this.createTierURL, body));
    }

    getTiers() {
        return fetchWithRetry(API.get<Tier[]>(this.getTiersURL));
    }

    getTierById(id: number) {
        return fetchWithRetry(API.get<Tier>(`${this.getTierByIdURL}/${id}`));
    }

    updateTier(body: UpdateTierBody) {
        return fetchWithRetry(API.put(this.updateTierURL, body));
    }

    deleteTier(id: number) {
        return fetchWithRetry(API.delete(`${this.deleteTierURL}/${id}`));
    }
}

export default new TierService();

